/**************************************************
 * Nombre:       BarraCorreo
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, InputAdornment, TextField} from "@mui/material";
import {Search} from '@mui/icons-material'

const BarraCorreo = ({difiere = false}) => {

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'center'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                backgroundColor: '#fff',
                borderRadius: 4,
                p: 2,

            }}
            spacing={2}
        >

            <Grid container size={{xs: 12, sm: 12, md: 5}} sx={{justifyContent: 'flex-start'}}>
                <TextField
                    label={'Correo Electronico'}
                    variant="standard"
                    slotProps={{
                        input: {
                            startAdornment: (

                                <InputAdornment position="start">
                                    <Search sx={{fill: '#000000'}}/>
                                </InputAdornment>
                            ),
                            disableUnderline: true,
                        },
                        inputLabel: {
                            sx: {marginLeft: -1}
                        }
                    }
                    }
                    placeholder={'micorreo@gmail.com'}
                />
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 7}} sx={{justifyContent: 'flex-start'}}>
                <Button color={'secondary'} fullWidth
                        sx={{
                            color: '#fff',
                            borderRadius: 20,
                            fontSize: difiere ? 16 : 14,
                            pt: 1.4,
                            pb: 1.2,
                            lineHeight: 1.2,
                            backgroundColor: difiere ? '#ED6BF8' : '#91DDCF'
                        }}>Regístrate
                    y recibe el 15% de
                    descuento.</Button>
            </Grid>

        </Grid>
    )

}
export default BarraCorreo